import React from 'react';

export default function ProfileScreen({ user, score, scoreColor, scoreLvl, discount, totalRides, avgRating, maxYears, onNavigateConnect, onLogout }) {
  return (
    <div className="fade-up" style={{ padding:'20px 20px 100px', maxWidth:500, margin:'0 auto' }}>

      {/* Avatar + info */}
      <div style={{ textAlign:'center', marginBottom:28 }}>
        <div style={{
          width:76, height:76, borderRadius:'50%',
          background:'linear-gradient(135deg, var(--orange), var(--orange-lt))',
          display:'flex', alignItems:'center', justifyContent:'center',
          fontSize:30, fontWeight:700, color:'#fff',
          fontFamily:'var(--font-display)',
          margin:'0 auto 14px',
          boxShadow:'var(--shadow-orange)',
        }}>
          {user?.name?.[0] || 'M'}
        </div>
        <h2 style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, color:'#fff', marginBottom:4 }}>
          {user?.name || 'Motorista'}
        </h2>
        <p style={{ color:'var(--grey-4)', fontSize:13, marginBottom:12 }}>{user?.email}</p>
        <span className="badge badge-orange">⭐ Nível {scoreLvl} · {score} pts</span>
      </div>

      {/* Stats grid */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:24 }}>
        {[
          ['💰', `${discount}%`,                                        'Desconto ativo'],
          ['🚗', totalRides > 0 ? totalRides.toLocaleString('pt-BR') : '—', 'Corridas totais'],
          ['⭐', avgRating > 0 ? avgRating.toFixed(2) : '—',             'Avaliação média'],
          ['📅', maxYears > 0 ? `${maxYears} anos` : '—',                 'Tempo ativo'],
        ].map(([icon, val, lbl]) => (
          <div key={lbl} style={{
            background:'var(--surface)',
            border:'1px solid var(--border)',
            borderRadius:'var(--radius-lg)',
            padding:'18px 14px',
            textAlign:'center',
          }}>
            <div style={{ fontSize:22, marginBottom:6 }}>{icon}</div>
            <div style={{ fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, color:'#fff', marginBottom:2 }}>
              {val}
            </div>
            <div style={{ fontSize:12, color:'var(--grey-4)' }}>{lbl}</div>
          </div>
        ))}
      </div>

      {/* Score level card */}
      <div style={{
        background:'linear-gradient(135deg, rgba(255,92,0,0.1), rgba(255,92,0,0.03))',
        border:'1px solid rgba(255,92,0,0.2)',
        borderRadius:'var(--radius-lg)',
        padding:18, marginBottom:16,
        display:'flex', justifyContent:'space-between', alignItems:'center',
      }}>
        <div>
          <div style={{ fontSize:12, color:'var(--grey-3)', marginBottom:4 }}>Seu nível atual</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:18, fontWeight:700, color:scoreColor }}>
            {scoreLvl}
          </div>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:12, color:'var(--grey-3)', marginBottom:4 }}>Desconto garantido</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:28, fontWeight:800, color:'var(--orange)' }}>
            {discount}% OFF
          </div>
        </div>
      </div>

      {/* Actions */}
      <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
        <button
          className="btn btn-ghost"
          style={{ width:'100%', justifyContent:'flex-start', padding:'14px 18px', textAlign:'left' }}
          onClick={onNavigateConnect}
        >
          🔗 Gerenciar apps conectados
        </button>
        <button
          className="btn btn-ghost"
          style={{ width:'100%', justifyContent:'flex-start', padding:'14px 18px', textAlign:'left' }}
        >
          ⚙️ Configurações da conta
        </button>
        <button
          className="btn btn-ghost"
          style={{ width:'100%', justifyContent:'flex-start', padding:'14px 18px', textAlign:'left', color:'#F87171', borderColor:'rgba(248,113,113,0.2)' }}
          onClick={onLogout}
        >
          🚪 Sair da conta
        </button>
      </div>
    </div>
  );
}
